import './scss/app.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './filters'

import axios from 'axios'

import StackTrace from 'stacktrace-js'

import AppNotify from 'app-notify';
Vue.use(AppNotify)

Vue.config.productionTip = false

axios.interceptors.request.use((config) => {
    config['headers']['Content-Type'] = 'application/json';
    config['headers']['X-Requested-With'] = 'XMLHttpRequest';
    return config;
},
(error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
    return res
},
async (error) => {
    return Promise.reject(error)
});

router.beforeEach(async (to, _from, next) => {
    // await store.dispatch('checkLogin')
    let user = store.state.user

    if ((!user) && (to.path != '/login' && to.path != '/register' && to.path != '/forgot-password' && to.path != '/reset-password')) {
        sessionStorage.after_login = to.path
        next('/login')
        return
    }
    else if (!!user && (to.path == '/login' || to.path == '/register' || to.path == '/forgot-password')) {
        next('/')
        return
    }
    else if (!!user && !user.superuser) {
        // console.log('yay', to)
        if (to.params.folder !== undefined) {
            try {
                await axios.get(`/api/files/${to.params.folder}`, {
                    params: {
                        fields: 'id,display_name,folder'
                    },
                })
            }
            catch (ex) {
                store.dispatch('showRequestAccess', to.params.folder)
                return
            }
        }
    }
    
    next()
})


const notify = new AppNotify();
const app = new Vue({
    notify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')


window.onerror = async (msg, source, lineno, colno, error) => {
  // console.error(error)
  
  let frames = await StackTrace.fromError(error)

  const data = {
    message: msg,
    frames: frames,
  }

  axios.post('/api/client-logger', data);
}

